module.exports = __webpack_public_path__ + "24b2ab7ec02f3ff4daeec0ee2c15b473.png";